import React from 'react';

import { useNavigation } from '@react-navigation/native';
import { getPlatform } from '@utils/getPlatform';

import {
  Button,
  ButtonContent,
  ButtonIcon,
  ButtonText,
  Container
} from './styles';

const BackButton: React.FC = () => {
  const navigation = useNavigation();

  return (
    <Container>
      <Button>
        <ButtonContent>
          <ButtonIcon
            testID="backbutton"
            name="ios-arrow-round-back"
            size={28}
            onPress={() =>
              // eslint-disable-next-line no-restricted-globals
              getPlatform() === 'web'
                ? window.history.back()
                : navigation.goBack()
            }
          />
        </ButtonContent>
        <ButtonText>Voltar</ButtonText>
      </Button>
    </Container>
  );
};

export default BackButton;
